"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateParams = exports.validateQuery = exports.validateBody = void 0;
const validator_1 = require("./validator");
const result_1 = require("@leavy/result");
/**
 * Express middleware that validates the request body against the specified class model.
 * @param bodyType - The class model used to validate the body.
 */
function validateBody(bodyType) {
    return async (req, res, next) => {
        const validationResult = await validator_1.validateAsync(bodyType, { ...req.body });
        if (!validationResult.success) {
            res.status(400);
            res.json(result_1.HttpResult.fromBad(validationResult));
        }
        else {
            req.body = validationResult.value;
            next();
        }
    };
}
exports.validateBody = validateBody;
/**
 * Express middleware that validates the request query string against the specified class model.
 * @param queryType - The class model used to validate the query.
 */
function validateQuery(queryType) {
    return async (req, res, next) => {
        const validationResult = await validator_1.validateAsync(queryType, { ...req.query });
        if (!validationResult.success) {
            res.status(400);
            res.json(result_1.HttpResult.fromBad(validationResult));
        }
        else {
            req.query = validationResult.value;
            next();
        }
    };
}
exports.validateQuery = validateQuery;
/**
 * Express middleware that validates the route parameters against the specified class model.
 * @param paramsType - The class model used to validate the route parameters.
 */
function validateParams(paramsType) {
    return async (req, res, next) => {
        const validationResult = await validator_1.validateAsync(paramsType, { ...req.params });
        if (!validationResult.success) {
            res.status(400);
            res.json(result_1.HttpResult.fromBad(validationResult));
        }
        else {
            req.params = validationResult.value;
            next();
        }
    };
}
exports.validateParams = validateParams;
//# sourceMappingURL=express.js.map